/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_Creator_GoneInputs */



/**
* | output |
* | --- |
* | "Former member" |
*
* @param {Agent_Policy_Destructive_Confirm_Creator_GoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_creator_gone = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_Creator_GoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_Creator_GoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ehemaliges Mitglied")
	return /** @type {LocalizedString} */ ("Former member")
});